<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="(item,index) in statisticsItems"
          :key="index"
          :cols="item.size"
          class="mb-2"
          :class="item.customClass"
        >
          <template v-if="layout==='donut'">
            <div class="text-center">

              <!-- apex chart -->
              <donut
                :statistic="item.title"
                :color="item.color"
                :box-height="boxHeight"
              />

              <div class="truncate">
                <h6>{{ item.text||item.groupName||item.questionName }}</h6>
                <span class="small">{{ $t(item.subtitle) }}</span>
              </div>
            </div>
          </template>
          <template v-if="layout==='vertical'">
            <div class="text-center">
              <b-avatar
                class="mb-1"
                :variant="item.color"
                size="48"
              >
                <feather-icon
                  size="21"
                  :icon="item.icon"
                />
              </b-avatar>
              <div class="truncate">
                <h2 class="mb-25 font-weight-bolder">
                  {{ item.title }}
                </h2>
                <h6>{{ item.text||item.groupName||item.questionName }}</h6>
                <span class="small">{{ $t(item.subtitle) }}</span>
              </div>
            </div>
          </template>
          <template v-if="layout==='horizontal'">
            <b-media no-body>
              <b-media-aside

                class="mr-2"
              >
                <b-avatar
                  size="48"
                  class="mb-1"

                  :variant="item.color"
                >
                  <feather-icon
                    size="24"
                    :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title }}
                </h4>
                <h6 v-if="item.text">
                  {{ item.text }}
                </h6>
                <h6 v-else>
                  {{ item.groupName||item.questionName }}
                </h6>
                <b-card-text class="font-small-3 mb-0">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </template>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

import Donut from '@/layouts/components/Donut.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    Donut,
  },
  props: {
    layout: {
      type: String,
      default: 'vertical',
    },
    statisticsItems: {
      type: Array,
      default: null,
    },
    boxHeight: {
      type: [Number, String],
      default: 'full',
    },
  },
}
</script>
